import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Button,
  Paper,
  Card,
  CardContent,
  CardMedia
} from '@mui/material';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

const MarketingPage = () => {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 12,
          textAlign: 'center',
          borderRadius: { xs: 0, md: '0 0 50% 50% / 40px' },
          boxShadow: '0 4px 20px rgba(233, 30, 99, 0.2)'
        }}
      >
        <Container maxWidth="md">
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom
            sx={{ 
              fontWeight: 700, 
              fontFamily: '"Playfair Display", serif',
              mb: 3
            }}
          >
            La experiencia Blüm en tu bolsillo
          </Typography>
          <Typography variant="h5" sx={{ mb: 6, opacity: 0.95, fontWeight: 300 }}>
            Envía amor y belleza con solo unos toques. Descarga nuestra nueva app móvil y disfruta de ofertas exclusivas.
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            startIcon={<PhoneIphoneIcon />}
            sx={{ 
              bgcolor: 'white', 
              color: 'primary.main',
              px: 6,
              py: 2,
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: 700,
              textTransform: 'none',
              boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
              '&:hover': { 
                bgcolor: '#f5f5f5',
                transform: 'translateY(-2px)',
                boxShadow: '0 12px 30px rgba(0,0,0,0.2)'
              },
              transition: 'all 0.3s ease'
            }}
            onClick={() => window.alert('¡Próximamente en App Store y Google Play!')}
          >
            Descargar App
          </Button>
        </Container>
      </Box>

      {/* Features Section */}
      <Container maxWidth="lg" sx={{ py: 10 }}>
        <Typography 
          variant="h3" 
          component="h2" 
          align="center" 
          gutterBottom 
          sx={{ 
            color: '#1a1a1a', 
            mb: 8,
            fontFamily: '"Playfair Display", serif',
            fontWeight: 700
          }}
        >
          ¿Por qué usar nuestra App?
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper 
              elevation={0} 
              sx={{ 
                p: 5, 
                height: '100%', 
                textAlign: 'center', 
                borderRadius: 4,
                boxShadow: '0 8px 30px rgba(0,0,0,0.06)',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' }
              }}
            >
              <Box sx={{ bgcolor: 'rgba(233, 30, 99, 0.08)', p: 2, borderRadius: '50%', display: 'inline-flex', mb: 3 }}>
                <LocalFloristIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              </Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
                Catálogo Exclusivo
              </Typography>
              <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                Accede a diseños florales únicos y colecciones de temporada disponibles solo en la aplicación móvil.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper 
              elevation={0} 
              sx={{ 
                p: 5, 
                height: '100%', 
                textAlign: 'center', 
                borderRadius: 4,
                boxShadow: '0 8px 30px rgba(0,0,0,0.06)',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' }
              }}
            >
              <Box sx={{ bgcolor: 'rgba(156, 39, 176, 0.08)', p: 2, borderRadius: '50%', display: 'inline-flex', mb: 3 }}>
                <SpeedIcon sx={{ fontSize: 40, color: 'secondary.main' }} />
              </Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
                Envío Express
              </Typography>
              <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                Rastrea tu pedido en tiempo real y recibe notificaciones instantáneas sobre el estado de tu entrega.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper 
              elevation={0} 
              sx={{ 
                p: 5, 
                height: '100%', 
                textAlign: 'center', 
                borderRadius: 4,
                boxShadow: '0 8px 30px rgba(0,0,0,0.06)',
                transition: 'transform 0.3s ease',
                '&:hover': { transform: 'translateY(-5px)' }
              }}
            >
              <Box sx={{ bgcolor: 'rgba(76, 175, 80, 0.08)', p: 2, borderRadius: '50%', display: 'inline-flex', mb: 3 }}>
                <SecurityIcon sx={{ fontSize: 40, color: 'success.main' }} />
              </Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, fontFamily: '"Playfair Display", serif' }}>
                Pago Seguro
              </Typography>
              <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
                Guarda tus métodos de pago y direcciones favoritas para realizar compras en segundos con total seguridad.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      {/* App Showcase / Call to Action */}
      <Box sx={{ bgcolor: '#fafafa', py: 10 }}>
        <Container maxWidth="md">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography 
                variant="h4" 
                gutterBottom 
                sx={{ 
                  fontWeight: 700, 
                  color: 'primary.main',
                  fontFamily: '"Playfair Display", serif'
                }}
              >
                Lleva la frescura contigo
              </Typography>
              <Typography paragraph color="text.secondary" sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                Nuestra aplicación está diseñada para hacer que regalar flores sea más fácil que nunca. 
                Gestiona tus pedidos, repite compras anteriores y programa envíos para fechas especiales.
              </Typography>
              <Box sx={{ mt: 4 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
                  Disponible próximamente en:
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Button 
                    variant="outlined" 
                    startIcon={<PhoneIphoneIcon />}
                    sx={{ 
                      borderRadius: '50px',
                      textTransform: 'none',
                      borderWidth: 2,
                      fontWeight: 600,
                      px: 3,
                      '&:hover': { borderWidth: 2 }
                    }}
                  >
                    App Store
                  </Button>
                  <Button 
                    variant="outlined" 
                    startIcon={<PhoneIphoneIcon />}
                    sx={{ 
                      borderRadius: '50px',
                      textTransform: 'none',
                      borderWidth: 2,
                      fontWeight: 600,
                      px: 3,
                      '&:hover': { borderWidth: 2 }
                    }}
                  >
                    Google Play
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
              {/* Placeholder for App Screenshot */}
              <Box 
                sx={{ 
                  width: 280, 
                  height: 560, 
                  bgcolor: 'white', 
                  borderRadius: 8, 
                  border: '8px solid #333',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 20px 50px rgba(0,0,0,0.15)',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <Box 
                  sx={{ 
                    position: 'absolute', 
                    top: 0, 
                    left: 0, 
                    right: 0, 
                    height: 30, 
                    bgcolor: '#333', 
                    borderBottomLeftRadius: 10, 
                    borderBottomRightRadius: 10,
                    zIndex: 1,
                    mx: 6
                  }} 
                />
                <Typography variant="body2" color="text.secondary">
                  Vista previa de la App
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default MarketingPage;
